// WhooLive Web Portal — Mock Data Layer
// Purely local/static data used during the design phase.
// This mirrors the SHAPE we expect from the future WhooLive APIs so the
// swap to real endpoints is a drop-in replacement.

const LIVE_IMAGES = [
  "https://images.unsplash.com/photo-1565035010268-a3816f98589a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjb25jZXJ0JTIwbGl2ZSUyMHN0cmVhbSUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4MjE2ODg5NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwbGl2ZSUyMHN0cmVhbSUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4MjE2ODg5NXww&ixlib=rb-4.1.0&q=85",
];

const EVENT_IMAGES = [
  "https://images.unsplash.com/photo-1561577862-49a301dda61b",
  "https://images.unsplash.com/photo-1605286232233-e448650f5914",
  "https://images.unsplash.com/photo-1468359601543-843bfaef291a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxjb25jZXJ0JTIwbGl2ZSUyMHN0cmVhbSUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4MjE2ODg5NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1514525253161-7a46d19cd819",
  "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3",
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30",
];

const AVATARS = [
  "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6",
  "https://images.pexels.com/photos/7897307/pexels-photo-7897307.jpeg",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
  "https://images.pexels.com/photos/6338370/pexels-photo-6338370.jpeg",
];

export const MOCK_USERS = [
  {
    id: "u1",
    username: "maya.rivers",
    displayName: "Maya Rivers",
    avatar: AVATARS[0],
    bio: "DJ & producer. Streaming rooftop sets across the city. 🎧",
    location: "Lisbon, PT",
    followers: 18420,
    following: 312,
    verified: true,
    tags: ["Music", "Nightlife", "DJ"],
  },
  {
    id: "u2",
    username: "leo.kane",
    displayName: "Leo Kane",
    avatar: AVATARS[2],
    bio: "Street food explorer. Live from markets around the world.",
    location: "Bangkok, TH",
    followers: 9210,
    following: 540,
    verified: false,
    tags: ["Food", "Travel"],
  },
  {
    id: "u3",
    username: "aria.n",
    displayName: "Aria Noor",
    avatar: AVATARS[1],
    bio: "Founder @ WhooLive. Building the future of live discovery.",
    location: "San Francisco, US",
    followers: 40120,
    following: 190,
    verified: true,
    tags: ["Tech", "Startups"],
  },
  {
    id: "u4",
    username: "sam.field",
    displayName: "Sam Field",
    avatar: AVATARS[3],
    bio: "Runner & community organizer. Weekend meetups & live races.",
    location: "Berlin, DE",
    followers: 5230,
    following: 610,
    verified: false,
    tags: ["Sports", "Community"],
  },
];

const userRef = (id) => {
  const u = MOCK_USERS.find((x) => x.id === id);
  return { id: u.id, username: u.username, displayName: u.displayName, avatar: u.avatar, verified: u.verified };
};

export const MOCK_LIVE_STREAMS = [
  {
    id: "l1",
    title: "Sunset Rooftop DJ Set — Live from Alfama",
    thumbnail: LIVE_IMAGES[0],
    category: "Music",
    viewers: 2412,
    isLive: true,
    startedAt: "2026-06-12T18:30:00Z",
    host: userRef("u1"),
    location: { name: "Alfama Rooftop", city: "Lisbon", lat: 38.7139, lng: -9.1265 },
    tags: ["DJ", "House", "Sunset"],
  },
  {
    id: "l2",
    title: "Night Market Food Crawl 🍜",
    thumbnail: LIVE_IMAGES[1],
    category: "Food",
    viewers: 874,
    isLive: true,
    startedAt: "2026-06-12T13:00:00Z",
    host: userRef("u2"),
    location: { name: "Yaowarat Rd", city: "Bangkok", lat: 13.7401, lng: 100.5106 },
    tags: ["Street Food", "Travel"],
  },
  {
    id: "l3",
    title: "Building in Public — Q&A with the WhooLive team",
    thumbnail: EVENT_IMAGES[3],
    category: "Tech",
    viewers: 1560,
    isLive: true,
    startedAt: "2026-06-12T16:00:00Z",
    host: userRef("u3"),
    location: { name: "SoMa Studio", city: "San Francisco", lat: 37.7785, lng: -122.4056 },
    tags: ["Startups", "AMA"],
  },
];

export const MOCK_EVENTS = [
  {
    id: "e1",
    title: "Waterfront Summer Music Festival",
    cover: EVENT_IMAGES[0],
    category: "Music",
    startsAt: "2026-07-04T17:00:00Z",
    endsAt: "2026-07-04T23:30:00Z",
    price: "From $39",
    host: userRef("u1"),
    location: { name: "Docklands Pier 7", city: "Lisbon", lat: 38.7071, lng: -9.1355 },
    attendees: 1280,
    capacity: 2000,
    tags: ["Festival", "Outdoor", "Live"],
    description:
      "A full evening of live sets from independent artists on the waterfront. Food trucks, art installations, and a sunset headline show.",
  },
  {
    id: "e2",
    title: "Founders Night: Live Fireside Chat",
    cover: EVENT_IMAGES[1],
    category: "Tech",
    startsAt: "2026-06-20T18:30:00Z",
    endsAt: "2026-06-20T21:00:00Z",
    price: "Free",
    host: userRef("u3"),
    location: { name: "SoMa Studio", city: "San Francisco", lat: 37.7785, lng: -122.4056 },
    attendees: 340,
    capacity: 400,
    tags: ["Networking", "Startups"],
    description:
      "An intimate fireside chat with founders building the next wave of live social products, streamed live on WhooLive.",
  },
  {
    id: "e3",
    title: "Sunrise 10K City Run",
    cover: EVENT_IMAGES[4],
    category: "Sports",
    startsAt: "2026-06-28T06:00:00Z",
    endsAt: "2026-06-28T09:00:00Z",
    price: "$15",
    host: userRef("u4"),
    location: { name: "Tiergarten Gate", city: "Berlin", lat: 52.5145, lng: 13.3501 },
    attendees: 620,
    capacity: 800,
    tags: ["Running", "Community", "Outdoor"],
    description:
      "Join the community for a scenic sunrise 10K through the heart of the city. Live-tracked and streamed for supporters.",
  },
  {
    id: "e4",
    title: "Street Food & Lantern Night",
    cover: EVENT_IMAGES[2],
    category: "Food",
    startsAt: "2026-07-11T19:00:00Z",
    endsAt: "2026-07-11T23:00:00Z",
    price: "From $12",
    host: userRef("u2"),
    location: { name: "Old Town Square", city: "Bangkok", lat: 13.7455, lng: 100.5013 },
    attendees: 940,
    capacity: 1500,
    tags: ["Food", "Culture", "Nightlife"],
    description:
      "A vibrant evening of regional street food, live cooking demos, and a lantern release — hosted and streamed live.",
  },
  {
    id: "e5",
    title: "Indie Film Premiere & Rooftop Screening",
    cover: EVENT_IMAGES[5],
    category: "Arts",
    startsAt: "2026-07-02T20:00:00Z",
    endsAt: "2026-07-02T23:00:00Z",
    price: "$25",
    host: userRef("u3"),
    location: { name: "Skyline Terrace", city: "San Francisco", lat: 37.7899, lng: -122.401 },
    attendees: 210,
    capacity: 300,
    tags: ["Film", "Arts", "Rooftop"],
    description:
      "An open-air premiere of a new independent short film, followed by a live Q&A with the cast and crew.",
  },
  {
    id: "e6",
    title: "Late Night House Warehouse Session",
    cover: LIVE_IMAGES[1],
    category: "Music",
    startsAt: "2026-06-21T22:00:00Z",
    endsAt: "2026-06-22T04:00:00Z",
    price: "From $29",
    host: userRef("u1"),
    location: { name: "Warehouse 12", city: "Lisbon", lat: 38.7412, lng: -9.1602 },
    attendees: 780,
    capacity: 1000,
    tags: ["House", "Nightlife", "Live"],
    description:
      "Deep, melodic house until sunrise in a raw warehouse space. Streamed live for those who can't make it in person.",
  },
];

export const MOCK_CHAT = [
  { id: "c1", user: "nova_", text: "this set is unreal 🔥", ts: 0 },
  { id: "c2", user: "kai.m", text: "where is this?? need to go", ts: 1 },
  { id: "c3", user: "ellie", text: "the sunset behind them 😍", ts: 2 },
  { id: "c4", user: "dmitri", text: "track ID please!", ts: 3 },
  { id: "c5", user: "sora", text: "joined from Tokyo, sound is crisp", ts: 4 },
  { id: "c6", user: "june", text: "how long is the stream tonight?", ts: 5 },
  { id: "c7", user: "marco", text: "goosebumps. following now", ts: 6 },
  { id: "c8", user: "priya", text: "the crowd energy is insane", ts: 7 },
];

export const CATEGORIES = ["All", "News", "Music", "Sports", "Party", "Food", "Nature", "Other"];

// ---- Homepage sections (mock) ----------------------------------------------

const inHours = (h) => new Date(Date.now() + h * 3600 * 1000).toISOString();
const daysAgo = (d) => new Date(Date.now() - d * 86400 * 1000).toISOString();

export const MOCK_FEATURED_LIVE = {
  id: "l1",
  title: "Sunset Rooftop DJ Set",
  subtitle: "Live from Alfama, Lisbon",
  hero:
    "https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  category: "Music",
  viewers: 2412,
  host: userRef("u1"),
  location: { name: "Alfama Rooftop", city: "Lisbon" },
  tags: ["DJ", "House", "Sunset"],
  tagline: "Featured live now",
  description: "Maya spins a melodic house set as the sun drops over the old town.",
};

export const MOCK_CATEGORIES = [
  { name: "Music", icon: "music", count: 128, gradient: "from-blue-500 to-indigo-600" },
  { name: "Nightlife", icon: "sparkles", count: 86, gradient: "from-fuchsia-500 to-purple-600" },
  { name: "Food", icon: "utensils", count: 64, gradient: "from-orange-500 to-red-500" },
  { name: "Tech", icon: "cpu", count: 42, gradient: "from-cyan-500 to-blue-600" },
  { name: "Sports", icon: "activity", count: 57, gradient: "from-emerald-500 to-teal-600" },
  { name: "Arts", icon: "palette", count: 39, gradient: "from-rose-500 to-pink-600" },
  { name: "Travel", icon: "plane", count: 71, gradient: "from-sky-500 to-cyan-500" },
  { name: "Gaming", icon: "gamepad", count: 93, gradient: "from-violet-500 to-indigo-600" },
];

export const MOCK_UPCOMING_LIVES = [
  {
    id: "up1",
    title: "Warehouse After-Hours: Melodic Techno",
    thumbnail:
      "https://images.unsplash.com/photo-1731194807352-402a0130adb5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Nightlife",
    host: userRef("u1"),
    scheduledFor: inHours(3),
    location: { name: "Warehouse 12", city: "Lisbon" },
  },
  {
    id: "up2",
    title: "Building in Public — Live Product Teardown",
    thumbnail:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Tech",
    host: userRef("u3"),
    scheduledFor: inHours(9),
    location: { name: "SoMa Studio", city: "San Francisco" },
  },
  {
    id: "up3",
    title: "Midnight Street Food Tour",
    thumbnail:
      "https://images.unsplash.com/photo-1514327567052-1eed4e4902c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Food",
    host: userRef("u2"),
    scheduledFor: inHours(26),
    location: { name: "Yaowarat Rd", city: "Bangkok" },
  },
  {
    id: "up4",
    title: "Gallery Walkthrough: New Contemporary Wing",
    thumbnail:
      "https://images.unsplash.com/photo-1606819717115-9159c900370b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Arts",
    host: userRef("u3"),
    scheduledFor: inHours(50),
    location: { name: "Skyline Terrace", city: "San Francisco" },
  },
];

export const MOCK_REPLAYS = [
  {
    id: "rp1",
    title: "Full Set: Waterfront Festival Headline",
    thumbnail:
      "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Music",
    host: userRef("u1"),
    duration: "1:24:06",
    views: 45213,
    recordedAt: daysAgo(2),
  },
  {
    id: "rp2",
    title: "Night Market Food Crawl — Bangkok",
    thumbnail:
      "https://images.unsplash.com/photo-1535898331935-2d274aff0fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Food",
    host: userRef("u2"),
    duration: "48:19",
    views: 18740,
    recordedAt: daysAgo(4),
  },
  {
    id: "rp3",
    title: "Rooftop Lounge Sessions Vol. 3",
    thumbnail:
      "https://images.unsplash.com/photo-1621275471769-e6aa344546d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Nightlife",
    host: userRef("u1"),
    duration: "2:03:44",
    views: 32960,
    recordedAt: daysAgo(6),
  },
  {
    id: "rp4",
    title: "Founders Fireside — Season Finale",
    thumbnail:
      "https://images.unsplash.com/photo-1560439514-e960a3ef5019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    category: "Tech",
    host: userRef("u3"),
    duration: "56:31",
    views: 9820,
    recordedAt: daysAgo(9),
  },
];

export const MOCK_SPONSORED = {
  id: "sp1",
  label: "Sponsored",
  brand: "Aurora Audio",
  title: "Hear every beat like you're front row",
  description:
    "Studio-grade wireless headphones tuned for live music. 20% off for WhooLive members this week.",
  image:
    "https://images.unsplash.com/photo-1520170350707-b2da59970118?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cta: "Shop the drop",
};

export const MOCK_SKYLINE =
  "https://images.unsplash.com/photo-1684285746670-3d2eeed72192?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

// ---- New homepage layout datasets (mock) -----------------------------------

export const MOCK_NEARBY = [
  {
    id: "e1",
    title: "Street Food Festival",
    thumbnail:
      "https://images.unsplash.com/photo-1652265540591-608fe558633b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    city: "Chiado, Lisbon",
    status: "live",
    distanceKm: 0.3,
    watching: 1200,
  },
  {
    id: "e6",
    title: "Indie Band Live",
    thumbnail:
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    city: "Cais do Sodré, Lisbon",
    status: "live",
    distanceKm: 0.6,
    watching: 876,
  },
  {
    id: "e3",
    title: "City FC Match",
    thumbnail:
      "https://images.pexels.com/photos/35898730/pexels-photo-35898730.jpeg?auto=compress&cs=tinysrgb&w=900",
    city: "Estádio da Luz, Lisbon",
    status: "live",
    distanceKm: 1.1,
    watching: 3100,
  },
  {
    id: "e4",
    title: "Night Vibes Party",
    thumbnail:
      "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    city: "Bairro Alto, Lisbon",
    status: "upcoming",
    distanceKm: 1.4,
    time: "Today, 22:00",
  },
];

export const MOCK_POPULAR = [
  {
    id: "p1",
    liveId: "l1",
    title: "Rooftop Sessions Live",
    thumbnail:
      "https://images.unsplash.com/photo-1695128861516-d9b48461c04c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    viewers: 6900,
    views: 5600,
    city: "Lisbon",
  },
  {
    id: "p2",
    liveId: "l2",
    title: "Street Skate Jam",
    thumbnail:
      "https://images.unsplash.com/photo-1591311337241-cecfd26f1da1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    viewers: 200,
    views: 3200,
    city: "Porto",
  },
  {
    id: "p3",
    liveId: "l3",
    title: "Arena Night Live",
    thumbnail:
      "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    viewers: 2100,
    views: 2100,
    city: "Madrid",
  },
  {
    id: "p4",
    liveId: "l1",
    title: "Sunset Beach Club",
    thumbnail:
      "https://images.unsplash.com/photo-1663668566928-10d8cb7faa45?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    viewers: 800,
    views: 1500,
    city: "Ibiza",
  },
];

export const MOCK_HOME_CATEGORIES = [
  { name: "Music", icon: "music", color: "text-blue-600", bg: "bg-blue-100" },
  { name: "Sports", icon: "trophy", color: "text-emerald-600", bg: "bg-emerald-100" },
  { name: "Travel", icon: "plane", color: "text-sky-600", bg: "bg-sky-100" },
  { name: "Food", icon: "utensils", color: "text-orange-600", bg: "bg-orange-100" },
  { name: "News", icon: "newspaper", color: "text-red-600", bg: "bg-red-100" },
  { name: "Culture", icon: "drama", color: "text-purple-600", bg: "bg-purple-100" },
  { name: "More", icon: "more", color: "text-slate-500", bg: "bg-slate-100" },
];

export const MOCK_SPONSORS = ["Red Bull", "VISA", "Heineken", "SONY", "GoPro", "NIKE"];

// ---- Premium / paid events (mock) ------------------------------------------

const inMinutes = (m) => new Date(Date.now() + m * 60 * 1000).toISOString();

export const MOCK_PREMIUM_EVENTS = [
  {
    id: "pe1",
    type: "premium",
    status: "starting_soon",
    locked: true,
    title: "Aurora — Live in Concert",
    category: "Music",
    cover:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    trailer:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    startsAt: inMinutes(135),
    endsAt: inMinutes(255),
    replay: { durationHours: 48 },
    host: userRef("u1"),
    location: { name: "Coliseu dos Recreios", city: "Lisbon" },
    priceFrom: "€12",
    description:
      "An intimate one-night-only show blending live strings with electronic production. Attend in the room or stream in crystal-clear multi-cam from anywhere.",
    tags: ["Concert", "One night only", "Multi-cam"],
    tickets: {
      inPerson: {
        price: 49,
        currency: "€",
        available: 24,
        total: 200,
        perks: ["Reserved seating", "Meet & greet raffle", "Exclusive merch"],
      },
      online: {
        price: 12,
        currency: "€",
        unlimited: true,
        perks: ["Multi-cam HD stream", "48h replay access", "Live chat"],
      },
    },
  },
  {
    id: "pe2",
    type: "premium",
    status: "premium",
    locked: true,
    title: "Rooftop Cinema Under the Stars",
    category: "Arts",
    cover:
      "https://images.unsplash.com/photo-1621275471769-e6aa344546d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    trailer:
      "https://images.unsplash.com/photo-1621275471769-e6aa344546d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    startsAt: inHours(72),
    endsAt: inHours(74),
    replay: { durationHours: 24 },
    host: userRef("u3"),
    location: { name: "Skyline Terrace", city: "San Francisco" },
    priceFrom: "€9",
    description:
      "A curated indie film premiere on a rooftop, followed by a live director Q&A. Grab a seat under the stars or watch the premiere online.",
    tags: ["Premiere", "Q&A", "Rooftop"],
    tickets: {
      inPerson: {
        price: 35,
        currency: "€",
        available: 88,
        total: 120,
        perks: ["Deck chair + blanket", "Welcome drink", "Director Q&A"],
      },
      online: {
        price: 9,
        currency: "€",
        unlimited: true,
        perks: ["HD stream", "24h replay", "Live Q&A submission"],
      },
    },
  },
  {
    id: "pe3",
    type: "premium",
    status: "live",
    locked: true,
    title: "TechSummit 2026 — Opening Keynote",
    category: "Tech",
    cover:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    trailer:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    startsAt: inMinutes(-12),
    endsAt: inMinutes(108),
    replay: { durationHours: 48 },
    host: userRef("u3"),
    location: { name: "Moscone Center", city: "San Francisco" },
    priceFrom: "€19",
    description:
      "The keynote that sets the agenda for the year. In-person passes include the expo floor; online passes get the full keynote stream and session replays.",
    tags: ["Keynote", "Expo", "Networking"],
    tickets: {
      inPerson: {
        price: 89,
        currency: "€",
        available: 6,
        total: 500,
        perks: ["Expo floor access", "Networking lounge", "Swag bag"],
      },
      online: {
        price: 19,
        currency: "€",
        unlimited: true,
        perks: ["Full keynote stream", "All session replays", "Digital badge"],
      },
    },
  },
  {
    id: "pe4",
    type: "premium",
    status: "sold_out",
    locked: true,
    title: "Chef's Table — Live 7-Course Night",
    category: "Food",
    cover:
      "https://images.unsplash.com/photo-1535898331935-2d274aff0fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    trailer:
      "https://images.unsplash.com/photo-1535898331935-2d274aff0fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    startsAt: inHours(20),
    endsAt: inHours(22),
    replay: { durationHours: 24 },
    host: userRef("u2"),
    location: { name: "Mercado Central", city: "Bangkok" },
    priceFrom: "Sold out",
    description:
      "A live seven-course tasting hosted by a Michelin-trained chef. This experience is fully sold out — join the waitlist for the next edition.",
    tags: ["Tasting menu", "Intimate", "Chef-led"],
    tickets: {
      inPerson: {
        price: 120,
        currency: "€",
        available: 0,
        total: 40,
        perks: ["7-course tasting", "Wine pairing", "Signed menu"],
      },
      online: {
        price: 15,
        currency: "€",
        soldOut: true,
        perks: ["Kitchen-cam stream", "Recipe pack", "Replay"],
      },
    },
  },
];

export const MOCK_STARTING_SOON = [
  {
    id: "pe1",
    kind: "event",
    title: "Aurora — Live in Concert",
    thumbnail:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    host: userRef("u1"),
    startsAt: inMinutes(135),
    status: "starting_soon",
    type: "premium",
    priceFrom: "€12",
  },
  {
    id: "l2",
    kind: "live",
    title: "Late Night House Warehouse",
    thumbnail:
      "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    host: userRef("u1"),
    startsAt: inMinutes(24),
    status: "starting_soon",
    type: "free",
  },
  {
    id: "pe3",
    kind: "event",
    title: "TechSummit 2026 Keynote",
    thumbnail:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    host: userRef("u3"),
    startsAt: inMinutes(-12),
    status: "live",
    type: "premium",
    priceFrom: "€19",
  },
  {
    id: "l3",
    kind: "live",
    title: "Building in Public — AMA",
    thumbnail:
      "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    host: userRef("u3"),
    startsAt: inMinutes(310),
    status: "starting_soon",
    type: "free",
  },
];

export const MOCK_PAST_PREMIUM = [
  {
    id: "pe5",
    type: "premium",
    status: "premium",
    locked: true,
    title: "Midnight Jazz Session",
    category: "Music",
    cover:
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    trailer:
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    startsAt: inHours(-5),
    endsAt: inHours(-3),
    replay: { durationHours: 48 },
    host: userRef("u1"),
    location: { name: "Blue Note Lisbon", city: "Lisbon" },
    priceFrom: "€10",
    description:
      "A late-night jazz quartet recorded live. Replay included for online ticket holders for 48 hours.",
    tags: ["Jazz", "Late night", "Replay"],
    tickets: {
      inPerson: { price: 40, currency: "€", available: 0, total: 60, perks: ["Front table", "Welcome drink"] },
      online: { price: 10, currency: "€", unlimited: true, perks: ["HD stream", "48h replay", "Live chat"] },
    },
  },
  {
    id: "pe6",
    type: "premium",
    status: "premium",
    locked: true,
    title: "Sunrise Coastal Run",
    category: "Sports",
    cover:
      "https://images.pexels.com/photos/35898730/pexels-photo-35898730.jpeg?auto=compress&cs=tinysrgb&w=1600",
    trailer:
      "https://images.pexels.com/photos/35898730/pexels-photo-35898730.jpeg?auto=compress&cs=tinysrgb&w=1600",
    startsAt: inHours(-50),
    endsAt: inHours(-48),
    replay: null,
    host: userRef("u4"),
    location: { name: "Marginal Boardwalk", city: "Lisbon" },
    priceFrom: "€8",
    description:
      "A guided sunrise run along the coast. This was an in-person experience with no replay.",
    tags: ["Running", "Sunrise", "Community"],
    tickets: {
      inPerson: { price: 18, currency: "€", available: 0, total: 300, perks: ["Race bib", "Finisher medal"] },
      online: { price: 8, currency: "€", unlimited: true, perks: ["Live tracking"] },
    },
  },
  {
    id: "pe7",
    type: "premium",
    status: "premium",
    locked: true,
    title: "Design Systems Live Workshop",
    category: "Tech",
    cover:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&sat=-20",
    trailer:
      "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&sat=-20",
    startsAt: inHours(-27),
    endsAt: inHours(-25),
    replay: { durationHours: 72 },
    host: userRef("u3"),
    location: { name: "Online Studio", city: "Remote" },
    priceFrom: "€14",
    description:
      "A hands-on workshop on building scalable design systems. Replay available for 72 hours for ticket holders.",
    tags: ["Workshop", "Design", "Replay"],
    tickets: {
      inPerson: { price: 60, currency: "€", available: 12, total: 80, perks: ["Workbook", "Certificate"] },
      online: { price: 14, currency: "€", unlimited: true, perks: ["HD stream", "72h replay", "Resource pack"] },
    },
  },
];

// Baseline demo tickets so the "My Tickets" experience is populated on first visit.
export const MOCK_TICKETS = [
  { eventId: "pe1", type: "online", purchasedAt: daysAgo(1) },
  { eventId: "pe3", type: "inPerson", purchasedAt: daysAgo(2) },
  { eventId: "pe5", type: "online", purchasedAt: daysAgo(3) },
  { eventId: "pe6", type: "inPerson", purchasedAt: daysAgo(4) },
];

const ALL_PREMIUM = [...MOCK_PREMIUM_EVENTS, ...MOCK_PAST_PREMIUM];

export const findPremiumEvent = (id) => ALL_PREMIUM.find((e) => e.id === id) || null;

export const findEvent = (id) =>
  MOCK_EVENTS.find((e) => e.id === id) || ALL_PREMIUM.find((e) => e.id === id) || null;
export const findLive = (id) => MOCK_LIVE_STREAMS.find((l) => l.id === id) || null;
export const findUser = (username) =>
  MOCK_USERS.find((u) => u.username === username) || null;
export const eventsByHost = (userId) =>
  MOCK_EVENTS.filter((e) => e.host.id === userId);
export const livesByHost = (userId) =>
  MOCK_LIVE_STREAMS.filter((l) => l.host.id === userId);
